export default "__VITE_ASSET__QZMOzAnk__"